import { useTranslation } from "react-i18next";
import { Button, Col, Form, message, Modal, Radio, RadioChangeEvent, Row, Space, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { getCourseFormatId, publishOneContentCourse } from '../../../service/content-course/contenCourseApi'
import PublishShareModal from '../publish-share-modal'
import { get } from "lodash";

type Props = {
  open: boolean
  quickReviewId: number
  handleClose: () => void
  getListData: () => void
  setClearRowkey: (value: boolean) => void
  dataGeneralConfig: any
  dataGeneralCostConfig: any
}

export default function PublishContentCourseModal(props: Props) {
  const { t } = useTranslation();
  const { open, handleClose, getListData, quickReviewId, setClearRowkey, dataGeneralCostConfig } = props
  const [availableStatus, setAvailableStatus] = useState<any>(1);
  const [openShareModal, setOpenShareModal] = useState<boolean>(false);


  const [form] = Form.useForm()

  const validation = {
    codeTemplateSequence: {
      required: true,
      message: t("Vui lòng nhập mã mẫu chương", "Vui lòng nhập mã mẫu chương"),
    },
    namTemplateSection: {
      required: true,
      message: t("Vui lòng nhập tên mẫu chương", "Vui lòng nhập tên mẫu chương"),
    },
  };

  const radioItemList = [
    {
      value: 1,
      title: t("Thẻ ghi danh", "Thẻ ghi danh"),
      describe: t("Khóa học được xây dựng lộ trình trong quá trình giảng dạy tùy theo chất lượng học viên đăng ký. Người dùng có thể thực hiện tự ghi danh sau khi khóa học mở chức năng ghi danh hoặc được ghi danh bởi QTKH hoặc Giảng viên phụ trách", "Khóa học được xây dựng lộ trình trong quá trình giảng dạy tùy theo chất lượng học viên đăng ký. Người dùng có thể thực hiện tự ghi danh sau khi khóa học mở chức năng ghi danh hoặc được ghi danh bởi QTKH hoặc Giảng viên phụ trách"),
    },
    {
      value: 2,
      title: t("Riêng tư", "Riêng tư"),
      describe:
        t("Khóa học xuất bản ở chế độ không công khai, chỉ hiển thị với người dùng được ghi danh bởi QTKH hoặc Giảng viên phụ trách", "Khóa học xuất bản ở chế độ không công khai, chỉ hiển thị với người dùng được ghi danh bởi QTKH hoặc Giảng viên phụ trách"),
    },
    {
      value: 3,
      title: t("Tự do", "Tự do"),
      describe: t("Khóa học xuất bản ở chế độ công khai, mọi người dùng đều có thể thực hiện ghi danh sau khi khóa học mở ghi danh", "Khóa học xuất bản ở chế độ công khai, mọi người dùng đều có thể thực hiện ghi danh sau khi khóa học mở ghi danh"),
    },
  ];

  const handleRadioChange = (e: RadioChangeEvent) => {
    setAvailableStatus(e.target.value);
  };

  const getStatusCourseFormatId = async () => {
    await getCourseFormatId(quickReviewId).then((res) => {
      if (res.status === 200) {
        setAvailableStatus(!res?.data ? 1 : res?.data)
      }
    })
  };

  useEffect(() => {
    getStatusCourseFormatId()
  }, [open])
  return (
    <Form.Provider onFormFinish={async (name, { values, forms }) => {
      if (name === "publish-content-course") {
        const data = {
          idCourse: quickReviewId,
          courseFormatId: availableStatus
        }
        await publishOneContentCourse(data).then((res) => {
          if (res.status === 200) {
            message.success(t("Xuất bản khoá học thành công", "Xuất bản khoá học thành công"))
            handleClose()
            setClearRowkey(true)
            getListData()
          }
        })
      }
    }}>
      <Modal
        className="publish-content-course-modal"
        title={t("Xác nhận", "Xác nhận")}
        closeIcon={true}
        centered
        open={open}
        onCancel={handleClose}
        footer={null}
        width={"50%"}
      >
        <Form
          form={form}
          layout="vertical"
          name="publish-content-course"
        >
          <Row gutter={30} className='p-6'>
            <Col md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
              <Typography.Title level={5} className='text-center'>Bạn muốn xuất bản khoá học. Bạn có muốn thay đổi hình
                thức xuất bản khoá học không?</Typography.Title>
            </Col>

            <Col md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }} className='mt-2'>
              <Radio.Group value={availableStatus}>
                {radioItemList.map((item, index) => (
                  <div key={index} className="radio-item mt-2">
                    <Radio value={item.value} onChange={handleRadioChange}
                      disabled={item.value !== 2 && get(props.dataGeneralConfig, 'isScheduleByTeacher', false)}>
                      <Typography.Title
                        className="setting-chapter-title"
                        level={5}
                      >
                        {item.title}
                      </Typography.Title>
                      <p>{item.describe}</p>
                    </Radio>
                  </div>
                ))}
              </Radio.Group>
            </Col>

            <Col md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
              <div className='mt-9'>
                <Space className='float-right'>
                  <Button onClick={handleClose} className="btn btn-outlined">
                    <Typography.Text>
                      {t("Hủy", "Hủy")}
                    </Typography.Text>
                  </Button>
                  <Button className="" onClick={() => form.submit()}
                  >
                    <Typography.Text>
                      {t("Xuất bản", "Xuất bản")}
                    </Typography.Text>
                  </Button>
                  <Button className="btn btn-primary" onClick={() => {
                    form.submit()
                    setOpenShareModal(true)
                  }}
                  >
                    <Typography.Text>
                      {t("Xuất bản và chia sẻ", "Xuất bản và chia sẻ")}
                    </Typography.Text>
                  </Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
      <PublishShareModal
        open={openShareModal}
        dataGeneralCostConfig={dataGeneralCostConfig}
        dataGeneralConfig={props.dataGeneralConfig}
        availableStatus={availableStatus}
        handleClose={() => {
          setOpenShareModal(false)
          handleClose()
          getListData()
        }
        }
        quickReviewId={quickReviewId} />
    </Form.Provider>
  )
}
